import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'
import { authApi } from '@/services/api'
import toast from 'react-hot-toast'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui/button'

export default function Register() {
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const login = useAuthStore((s) => s.login)
  const navigate = useNavigate()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setLoading(true)
    try {
      const res = await authApi.register({ email, password, full_name: fullName })
      login(res.data.access, res.data.refresh)
      toast.success('Account created!')
      navigate('/')
    } catch (err: unknown) {
      const message = (err as { response?: { data?: { detail?: string } } })?.response?.data?.detail || 'Registration failed'
      toast.error(message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <h2 className="text-[21px] font-bold text-[#000A1E] leading-[32px] mb-1">Create your account</h2>
      <p className="text-[13px] text-[rgba(0,10,30,0.75)] mb-8">Start managing your clients&apos; books today</p>

      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="space-y-1">
          <Label htmlFor="full-name">Full name</Label>
          <Input
            id="full-name"
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder="Jane Smith"
            required
            className="h-10"
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="email">Email address</Label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@yourfirm.com"
            required
            className="h-10"
          />
        </div>
        <div className="space-y-1">
          <Label htmlFor="password">Password</Label>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Min. 8 characters"
            required
            minLength={8}
            className="h-10"
          />
        </div>
        <Button type="submit" disabled={loading} className="w-full h-10">
          {loading ? 'Creating account...' : 'Create account'}
        </Button>
      </form>

      <p className="text-[13px] text-center text-[rgba(0,10,30,0.75)] mt-6">
        Already have an account?{' '}
        <Link to="/login" className="text-[#0078C8] font-bold hover:underline">
          Sign in
        </Link>
      </p>
    </div>
  )
}
